
<div :id="content.idHTML" class="row mx-0 w-100" :class="jel_getClassObject(content)">
  <label class="mb-0" for="optionGroupeRadio">{{ content.libGroupeRadio }}</label>
  <GroupeRadio v-model="optionGroupeRadio" class="px-1 w-100" :content="contentRadioGroup" />

  <ListeChoix
    ref="libComboBox"
    v-model="optionComboBox"
    class="mt-0 w-100"
    :content="contentComboBox"
  />
</div>
